import React, { useState, useEffect, useRef } from "react";
import "../../App.css";
// Clients Page Component
function ClientsPage() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const intervalRef = useRef(null);

  const groups = [
    {
      title: 'Government Clients',
      images: [
        '/gov1.png', '/gov2.jpg', '/gov3.jpg', '/gov4.jpg', '/gov5.jpg',
        '/gov6.png', '/gov7.png', '/gov8.jpg', '/gov9.jpg', '/gov10.jpg',
        '/gov11.jpg', '/gov12.jpg', '/gov13.png', '/gov14.png', '/gov15.jpg',
        '/gov16.jpg', '/gov17.png', '/gov18.jpg', '/gov19.jpg', '/gov20.jpg',
        '/gov21.jpg', '/gov22.jpg'
      ],
      color: '#1a4fb8'
    },
    {
      title: 'Education Clients',
      images: [
        '/edu1.jpg', '/edu2.png', '/edu3.png', '/edu4.jpg', '/edu5.png',
        '/edu6.png', '/edu7.png', '/edu8.jpg', '/edu9.png', '/edu10.jpg',
        '/edu11.png', '/edu12.jpg', '/edu13.jpg', '/edu14.jpg',
        '/edu15.png', '/edu16.png', '/edu17.jpg', '/edu18.jpg', '/edu19.png'
      ],
      color: '#0ea5e9'
    },
    {
      title: 'Research Clients',
      images: [
        '/res1.jpg', '/res2.jpg', '/res3.png', '/res4.jpg', '/res5.jpg',
        '/res6.jpg', '/res7.jpg', '/res8.png', '/res9.jpg'
      ],
      color: '#10b981'
    },
  ];

  // Auto-slide functionality
  useEffect(() => {
    const startAutoSlide = () => {
      intervalRef.current = setInterval(() => {
        if (!isPaused) {
          setCurrentSlide((prev) => (prev + 1) % groups.length);
        }
      }, 4000); // Change slide every 5 seconds
    };

    startAutoSlide();

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isPaused, groups.length]);

  // Reset interval when slide changes manually
  const resetInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    intervalRef.current = setInterval(() => {
      if (!isPaused) {
        setCurrentSlide((prev) => (prev + 1) % groups.length);
      }
    }, 4000);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % groups.length);
    resetInterval();
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + groups.length) % groups.length);
    resetInterval();
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
    resetInterval();
  };

  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  return (
    <>
      <div className="clients-header">
        <div className="section__container">
          <h2 className="section__title">Our Clients</h2>
          <p className="section__intro">
            GEOTECH Geospatial is proud to serve a diverse portfolio of clients, including government agencies,
            enterprises, and public utilities. Our partnerships are a testament to our commitment to delivering
            high-quality, innovative geospatial solutions.
          </p>
        </div>
      </div>
      <div className="clients_bg">
        <section className="section clients-page">
          <div className="section__container">
            <div
              className="clients-slider"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {/* Navigation arrows */}
              <button
                className="slider-arrow slider-arrow--prev"
                onClick={prevSlide}
                aria-label="Previous slide"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

              <button
                className="slider-arrow slider-arrow--next"
                onClick={nextSlide}
                aria-label="Next slide"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

              {/* Play/Pause button */}


              {/* Slider content */}
              <div className="slider-container">
                <div
                  className="slider-track"
                  style={{
                    transform: `translateX(-${currentSlide * (100 / groups.length)}%)`,
                    width: `${groups.length * 100}%`
                  }}
                >
                  {groups.map(({ title, images, color }, idx) => (
                    <div
                      key={idx}
                      className="slide"
                      style={{ width: `${100 / groups.length}%` }}
                    >
                      <div className="client-category">
                        <h3 className="section__subtitle" style={{ color }}>
                          {title}
                        </h3>
                        <div className="client-grid">
                          {images.map((src, i) => (
                            <div key={i} className="client-card">
                              <div className="client-card__inner">
                                <img
                                  src={src}
                                  alt={`${title} ${i + 1}`}
                                  className="client-card__image"
                                  onError={e => (e.target.src = '/placeholder-client.png')}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Dot indicators with progress */}
              <div className="slider-indicators">
                {groups.map((group, idx) => (
                  <button
                    key={idx}
                    className={`slider-dot ${currentSlide === idx ? 'active' : ''}`}
                    onClick={() => goToSlide(idx)}
                    aria-label={`Go to ${group.title}`}
                  >
                    <div
                      className="slider-dot-fill"
                      style={{
                        backgroundColor: group.color,
                        animationPlayState: currentSlide === idx && !isPaused ? 'running' : 'paused'
                      }}
                    />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}


export default ClientsPage;